import React, { useEffect, useState } from "react";
import { Wrapper, Content,StyledLink } from "./InfoButton.styles.js";
import { Link } from "react-router-dom";




const InfoButton = ({text,IDonFile}) =>{


const [state,setState] = useState(false)


return(

<Wrapper IDonFile={IDonFile}>    
        
 <Content>
    <div>{text}</div>
 </Content>

  

</Wrapper>
)

}





export default InfoButton;